import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-azure",
  "use": "oc-azure-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"oc-azure\"><path d=\"M583.837538 157.538462l-110.00123 303.104a78.690462 78.690462 0 0 0 12.327384 75.776l196.844308 246.784-394.830769 72.349538h661.110154L583.837538 157.538462zM253.833846 389.198769L39.384615 785.723077l195.780923-0.472615L530.274462 157.538462z\" p-id=\"2730\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol